import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { z } from 'zod';

import { DashboardInsightViews } from '~/features/insights/os/insight-views';

/** `by=hand` opens the one insight editor (stage 6); without it Add an insight opens with OS first (board dashboard-os-add-ask). */
const search = z.object({ by: z.enum(['hand']).optional() });

function NewRoute(): ReactElement {
  const { by } = Route.useSearch();
  const navigate = Route.useNavigate();
  return <DashboardInsightViews cardKey={null} by={by ?? null} onBy={(next) => void navigate({ search: next === null ? {} : { by: next } })} />;
}

export const Route = createFileRoute('/_app/dashboard/new')({
  validateSearch: search,
  component: NewRoute,
});
